import { toast } from 'react-toastify'; 
import axios from 'axios';
import API from '../../config/apiconfig';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userManagementApiLoader } from '../../action/loaderActions';

export const useVerifyOTPInstance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const verifyOTP = ({ email, otp }) => {
      dispatch(userManagementApiLoader({isUsermanagementLoader: true}));
      const data = {
        "email" : email,
        "otp" : otp
      };
      axios.post(
          `${API.USER_MANAGEMENT_API_BASE_URL}${API.VERIFY_OTP}`,
          data,
          {
              headers: {
                  'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
              },
          }
      )
      .then((response) => {
        toast.success(response?.data?.message, {
          autoClose: 6000,
        });
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
        navigate('/login')
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || 'Error logging in!', {
          autoClose: 6000,
        });
        console.error('Error logging in:', error.response || error);
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      });
  };

  return { verifyOTP };
};
